var map = {
	"./affinity_logo": 82,
	"./affinity_logo.svg": 82,
	"./angle_down": 83,
	"./angle_down.png": 83,
	"./business_model": 84,
	"./business_model.svg": 84,
	"./custom": 85,
	"./custom.svg": 85,
	"./esg": 86,
	"./esg.svg": 86,
	"./locus_logo": 87,
	"./locus_logo.png": 87,
	"./macro_themes": 88,
	"./macro_themes.svg": 88,
	"./micro_themes": 89,
	"./micro_themes.svg": 89,
	"./sector": 90,
	"./sector.svg": 90,
	"./syntax_logo": 91,
	"./syntax_logo.svg": 91
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 192;